var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('melos-multiple-toggle',{attrs:{"options":_vm.options},on:{"click":_vm.onItemClicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }